import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';

/** Blocks a route unless a session exists, remembering where the user was headed. */
export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!session.isAuthenticated()) {
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }

  // Inactive students/teachers must activate before entering the panel.
  if (auth.needsActivation() && !state.url.startsWith('/auth/activate')) {
    return router.createUrlTree(['/auth/activate']);
  }

  return true;
};

/**
 * Keeps signed-in users out of guest auth screens (login/register/…).
 * Inactive accounts are sent to the promotion-code page instead.
 */
export const guestGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!session.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree([auth.postAuthRoute()]);
};

/** Activate page: must be signed in and still inactive. */
export const activateGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!session.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }
  if (!auth.needsActivation()) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  return true;
};
